import type { Profile } from '@/types'

/**
 * Check if a profile has admin role
 */
export function isAdmin(profile: Profile | null | undefined): boolean {
  return profile?.role === 'admin'
}
